import Item from "./selector";
import withPackingItem from "./withPackingItem";

export default withPackingItem(Item);
